module.exports = __webpack_public_path__ + "static/media/Screen Shot 2022-05-30 at 2.14.15 PM.3ff63660.png";